import _classCallCheck from '../../../../node_modules/@babel/runtime/helpers/classCallCheck.es.js';
import _createClass from '../../../../node_modules/@babel/runtime/helpers/createClass.es.js';
import _inherits from '../../../../node_modules/@babel/runtime/helpers/inherits.es.js';
import _possibleConstructorReturn from '../../../../node_modules/@babel/runtime/helpers/possibleConstructorReturn.es.js';
import _getPrototypeOf from '../../../../node_modules/@babel/runtime/helpers/getPrototypeOf.es.js';
import { flattenChildren } from '@mgmresorts/wcl-utils';
import React from 'react';
import { Button } from '../Button/Button.es.js';
import '../Button/FixedButton.es.js';
import '../Button/Button.styles.es.js';
import { StyledButtonGroupItem, StyledButtonGroup } from './ButtonGroup.styles.es.js';

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * Renders a <ButtonGroup /> component
 * @param {string} layout - set the layout of buttonGroup
 * @param {string} spacing - set the spacing between buttonGroup
 * @param {string} align - set the alignment of buttonGroup
 * @param {React.ReactNode} children - the children to be rendered inside the buttonGroup
 * @param {string} testId - set the testId on the buttonGroup
 **/

var ButtonGroup = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ButtonGroup, _React$PureComponent);

  var _super = _createSuper(ButtonGroup);

  function ButtonGroup(props) {
    var _this;

    _classCallCheck(this, ButtonGroup);

    _this = _super.call(this, props);
    _this._childrenValidationErrorThrown = false; // Ensures that developers are using this component in the way it was designed.

    _this._validateChildren(_this.props.children);

    return _this;
  }

  _createClass(ButtonGroup, [{
    key: "_validateChildren",
    value: function _validateChildren(children) {
      var _this2 = this;

      return flattenChildren(children).filter(function (child) {
        if (!_this2._isValidButton(child)) {
          if (!_this2._childrenValidationErrorThrown) {
            console.error("ButtonGroup has children that aren't Button components."); // Throw this error only once

            _this2._childrenValidationErrorThrown = true;
          }

          return false;
        }

        return true;
      });
    }
  }, {
    key: "_isValidButton",
    value: function _isValidButton(child) {
      return (child === null || child === void 0 ? void 0 : child.type) === Button;
    }
  }, {
    key: "_shouldPassFullWidthProp",
    value: function _shouldPassFullWidthProp() {
      return ['flex', 'flex-equal', 'inline-flex-equal', 'blocks'].includes(this.props.layout);
    }
  }, {
    key: "_renderChildren",
    value: function _renderChildren() {
      var _this3 = this;

      var _this$props = this.props,
          layout = _this$props.layout,
          children = _this$props.children,
          spacing = _this$props.spacing; // map over children and add a wrapper for spacing
      // also determine if we should pass the fullWidth
      // prop to the Button component based on the layout

      return this._validateChildren(children).map(function (child, i) {
        return /*#__PURE__*/React.createElement(StyledButtonGroupItem, {
          key: i,
          layout: layout,
          spacing: spacing
        }, /*#__PURE__*/React.cloneElement(child, _this3._shouldPassFullWidthProp() ? {
          fullWidth: 1
        } : {}));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          layout = _this$props2.layout,
          spacing = _this$props2.spacing,
          children = _this$props2.children,
          align = _this$props2.align;
      return /*#__PURE__*/React.createElement(StyledButtonGroup, {
        elements: children ? children.length : 0,
        align: align,
        spacing: spacing,
        layout: layout,
        "data-testid": ButtonGroup.displayName
      }, this._renderChildren());
    }
  }]);

  return ButtonGroup;
}(React.PureComponent);
ButtonGroup.displayName = 'ButtonGroup';
ButtonGroup.defaultProps = {
  spacing: 'medium',
  layout: 'flex',
  align: 'left',
  testId: 'ButtonGroup'
};

export { ButtonGroup };
